<template>
    <div  v-if="mini">
        <v-btn
            fab
            color="orange lighten-3"
            fixed
            right
            :small="!$vuetify.breakpoint.smAndDown"
            :large="!$vuetify.breakpoint.smAndDown"
            class="ma-4"
            @click="backTeletrabajo()"
        >
            <v-icon>mdi-chevron-left</v-icon>
            <v-icon>mdi-face-agent</v-icon>
        </v-btn>
        <v-btn
            fab
            color="deep-purple lighten-5"
            fixed
            right
            :small="!$vuetify.breakpoint.smAndDown"
            :large="!$vuetify.breakpoint.smAndDown"
            style="margin-right: 16px; !important; margin-top: 85px; !important;"
            @click="mini = !mini"
        >
            <v-icon>mdi-menu-close</v-icon>
        </v-btn>
    </div>
    <v-navigation-drawer
        v-else
        v-model="drawer"
        :mini-variant.sync="mini"
        permanent
        :style="!$vuetify.breakpoint.smAndDown ? 'min-width: 300px !important; max-width: 300px !important;' : 'position: fixed; z-index: 1000; width: 100%;'"
        color="deep-purple lighten-5"
    >
        <v-btn
            width="100%"
            class="d-flex justify-center"
            @click="backTeletrabajo()"
            depressed
            color="orange lighten-3"
        >
            <v-icon>mdi-chevron-left</v-icon>
            <v-icon>mdi-face-agent</v-icon>
        </v-btn>
        <v-btn
            width="100%"
            class="d-flex justify-center"
            @click.stop="mini = !mini"
            depressed
            color="transparent"
        >
            <v-icon>mdi-menu-open</v-icon>
        </v-btn>
        <v-list-item class="px-2">
            <v-img 
                class="header-img"
                src="/agent.png"
            ></v-img>
        </v-list-item>

        <v-list-item>
            <v-list-item-content v-if="!mini">
                <v-list-item-title class="text-center">
                    <v-btn
                        small
                        depressed
                        color="primary"
                        outlined
                        class="mb-2"
                    >
                        {{ customerName }}
                    </v-btn>
                </v-list-item-title>
                <v-btn
                    x-small
                    depressed
                    color="primary"
                    outlined
                >
                    {{ isPro ? 'Negocio' : 'Particular' }}
                </v-btn>
                <v-btn
                    x-small
                    depressed
                    color="primary"
                    outlined
                    v-for="(value, key) in userInfo"
                    :key="key"
                >
                    {{value}}
                </v-btn>
            </v-list-item-content>
            <v-list-item-content v-else>
                <v-icon>
                    mdi-card-account-details-outline
                </v-icon>
            </v-list-item-content>
        </v-list-item>

        <v-list dense rounded v-if="!mini">
            <v-list-group
                :value="true"
                prepend-icon="mdi-account-circle"
                v-for="(contracts, name) in agentCustInfo"
                :key="name"
            >
                <template v-slot:activator>
                    <v-list-item-content>
                        <v-list-item-title>{{ name }}</v-list-item-title>
                    </v-list-item-content>
                </template>
                <ul style="list-style-type: none; padding: 0; margin: 0;">
                    <li 
                        v-for="(contract, id) in contracts" 
                        :key="id"
                        @click="selected = contract; selectedId = id"
                        style="cursor: pointer; border-radius: 10px;"
                        :class="{'selected-item': selected === contract}"
                    >
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    Contrato - {{ contract.activations.name }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="d-flex justify-space-around">
                                    <AgentActivationsInfo
                                        :billingInfo="contract.activations"
                                        :invoices="contract.invoices.invoices"
                                    />
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-for="(line, index) in getLandLines(contract)"
                            :key="`land-${index}`"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-wifi</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ line }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-for="(line, index) in getMobileLines(contract)"
                            :key="`mobile-${index}`"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-cellphone</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ line }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            v-for="(line, index) in getAgileLines(contract)"
                            :key="`agile-${index}`"
                        >
                            <v-list-item-icon>
                                <v-icon>mdi-television</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ line }}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </li>
                </ul>
            </v-list-group>
        </v-list>
        <v-list v-else class="mt-n4">
            <v-list-item
                v-for="(contracts, name) in agentCustInfo"
                :key="name"
            >
                <v-icon>
                    mdi-file-document-check-outline
                </v-icon>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex';
import AgentActivationsInfo from './AgentActivationsInfo.vue';

export default {
    data: () => ({
        drawer: true,
        mini: false,
        selected: null,
        selectedId: null,
        isPro: false,
    }),
    components: {
        AgentActivationsInfo,
    },
    computed: {
        customerName() {
            try{
                const first_user_contracts = Object.values(this.agentCustInfo)[0];
                const {customer_info} = Object.values(first_user_contracts)[0];

                return `${customer_info?.personalInfo?.firstName} ${customer_info?.personalInfo?.middleName} ${customer_info?.personalInfo?.lastName}`;
            } catch (e) {
                return '';
            }
        },
        userInfo() {
            try{
                const first_user_contracts = Object.values(this.agentCustInfo)[0];
                const {customer_info} = Object.values(first_user_contracts)[0];

                return {
                    // segment: customer_info?.segmentType,
                    birthDate: customer_info?.personalInfo?.birthday,
                    document: customer_info?.personalInfo?.document?.id,
                    email: customer_info?.personalInfo?.contactInfo?.email,
                    phone: customer_info?.personalInfo?.contactInfo?.phone,
                }
            } catch (e) {
                return {};
            }
        },
        ...mapState('agent', {
            agentCustInfo: (state) => state.agentCustInfo,
        }),
    },
    methods: {
        getAgileLines(contract) {
            const {agile} = contract;
            return agile?.agileSubscriptions.map(
                (sub) => sub.installationPhone
            )
        },
        getLandLines(contract) {
            const {landline} = contract;
            return landline?.landlineSubscriptions.map(
                (sub) => sub.number
            )
        },
        getMobileLines(contract) {
            const {mobile} = contract;
            return mobile?.mobileSubscriptions.map(
                (sub) => sub.msisdn
            )
        },
        backTeletrabajo() {
            this.$store.commit('teletrabajo/currentView', 'Teletrabajo');
            this.$store.commit('agent/agentCustInfo', {});
        },
    },
    watch: {
        agentCustInfo: {
            handler() {
                // this.selected = null;
                this.$forceUpdate();
            },
            deep: true,
        },
        selected: {
            handler() {
                this.$emit('changedSelectedContract', this.selected);
                this.$emit('changedSelectedContractId', this.selectedId);
            },
            immediate: true,
        },
    },
    mounted() {
        const first_client_id = Object.keys(this.agentCustInfo)[0];
        const first_client = this.agentCustInfo[first_client_id];
        const first_contract_id = Object.keys(first_client)[0];
        this.selected = first_client[first_contract_id];
        this.selectedId = first_contract_id;

        this.isPro = this.selected?.landline?.landlineSubscriptions?.some(
            (sub) => String(sub.bundleName).toLowerCase().includes('pro')
        ) || this.selected?.mobile?.mobileSubscriptions.some(
            (sub) => String(sub.tariffName).toLowerCase().includes('pro')
        );
    },
};
</script>

<style scoped>
    .full-h {
        height: 100% !important;
        
    }
    .header-img {
        scale: 0.6;
        height: 260px;
        margin: -40px 0 -30px 0;
    }

    .selected-item {
        background-color: #ead6f9;
    }

    .selected-text {
        color: white;
    }

    @media screen and (max-width: 600px) {
        .header-img {
            scale: 0.5;
            height: 380px;
            margin: -70px 0 -70px 0;
        }
    }
</style>